import {
    IconBeach,
    IconBriefcase,
    IconCalendar,
    IconChecklist,
    IconClock,
    IconDeviceDesktopShare,
    IconFile,
    IconFileText,
    IconRobot,
    IconSettings,
    // IconLayoutDashboard,
    // IconShield,
    IconUserCheck,
    IconUsers,
} from '@tabler/icons-react';
import { AudioWaveform, Command, GalleryVerticalEnd } from 'lucide-react';
//   import { type SidebarData } from '../types'

export const sidebarData = {
    user: {
        name: 'PHUNG',
        email: 'phung@gmail.com',
        avatar: 'https://slack-imgs.com/?c=1&o1=gu&url=https%3A%2F%2Femoji.slack-edge.com%2FT024MFQVDD2%2Flt%2F3100f2ff4b59dceb.png',
    },
    teams: [
        {
            name: 'LuxTech',
            logo: Command,
            plan: 'luxtech.global@gmail.com',
        },
        {
            name: 'Acme Inc',
            logo: GalleryVerticalEnd,
            plan: 'Enterprise',
        },
        {
            name: 'Acme Corp.',
            logo: AudioWaveform,
            plan: 'Startup',
        },
    ],
    navGroups: [
        {
            title: 'General',
            items: [
                // {
                //     title: 'Dashboard',
                //     url: '/',
                //     icon: IconLayoutDashboard,
                // },
                {
                    title: 'Projects',
                    url: '/projects',
                    icon: IconBriefcase,
                },
                {
                    title: 'Tasks',
                    url: '/tasks',
                    icon: IconChecklist,
                },
                {
                    title: 'Report',
                    url: '/report',
                    icon: IconFileText,
                },
                {
                    title: 'Tracking Time',
                    url: '/tracking-time',
                    icon: IconClock,
                },
                {
                    title: 'Users',
                    url: '/',
                    icon: IconUsers,
                },
                // {
                //     title: 'Protected',
                //     url: '/protective',
                //     icon: IconShield,
                // },
                {
                    title: 'Day Off',
                    url: '/day-off',
                    icon: IconCalendar,
                },
                {
                    title: 'Attendance',
                    url: '/attendance',
                    icon: IconUserCheck,
                },
                {
                    title: 'WFH',
                    url: '/wfh',
                    icon: IconDeviceDesktopShare,
                },
                {
                    title: 'S3 File',
                    url: '/s3-file',
                    icon: IconFile,
                },
                {
                    title: 'Manual Log',
                    url: '/manual-log',
                    icon: IconFileText,
                },
                {
                    title: 'Setting',
                    url: '/setting/list-setting',
                    icon: IconSettings,
                },
                {
                    title: 'Test Prompt',
                    url: '/test-promt',
                    icon: IconRobot,
                },
                {
                    title: 'Leave',
                    url: '/leave',
                    icon: IconBeach,
                },
            ],
        },
        // {
        //     title: 'Other',
        //     items: [
        //         {
        //             title: 'Settings',
        //             icon: IconSettings,
        //             items: [
        //                 {
        //                     title: 'Profile',
        //                     url: '/settings',
        //                     icon: IconUserCog,
        //                 },
        //                 {
        //                     title: 'Account',
        //                     url: '/settings/account',
        //                     icon: IconTool,
        //                 },
        //                 {
        //                     title: 'Appearance',
        //                     url: '/settings/appearance',
        //                     icon: IconPalette,
        //                 },
        //                 {
        //                     title: 'Notifications',
        //                     url: '/settings/notifications',
        //                     icon: IconNotification,
        //                 },
        //                 {
        //                     title: 'Display',
        //                     url: '/settings/display',
        //                     icon: IconBrowserCheck,
        //                 },
        //             ],
        //         },
        //         {
        //             title: 'Help Center',
        //             url: '/help-center',
        //             icon: IconHelp,
        //         },
        //     ],
        // },
    ],
};
